import { stringToDate } from '@/utils/is-valid-date-string'
import { mergeObjectToSearchParams } from '@/utils/merge-object-to-search-params'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { z } from 'zod'

export const tableFilterSchema = z
  .object({
    openingDateStart: z.coerce.date().optional(),
    openingDateEnd: z.coerce.date().optional(),
    deadline: z.string().optional(),
    oldCourse: z.string().optional(),
    desiredCourse: z.string().optional(),
    status: z.string().optional(),
    previousIES: z.string().optional()
  })
  .superRefine((data, ctx) => {
    const { openingDateStart, openingDateEnd } = data

    if (
      openingDateStart
      && openingDateEnd
      && openingDateEnd < openingDateStart
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['openingDateEnd'],
        message: 'Data inválida'
      })

      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['openingDateStart'],
        message: 'Data inválida'
      })
    }
  })

export const useTableFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const defaultValues = {
    openingDateStart: undefined,
    openingDateEnd: undefined,
    deadline: '',
    oldCourse: '',
    desiredCourse: '',
    status: '',
    previousIES: ''
  }

  const {
    handleSubmit: submit,
    formState: { errors },
    watch,
    reset: resetForm,
    control,
    clearErrors
  } = useForm({
    resolver: zodResolver(tableFilterSchema),
    defaultValues
  })

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = submit((data: any) => {
    const formattedData = {
      ...data,
      page: '1'
    }
    mergeObjectToSearchParams(
      searchParams,
      setSearchParams,
      Object.entries(formattedData)
    )
  })

  const reset = () => {
    resetForm(defaultValues)
    mergeObjectToSearchParams(
      searchParams,
      setSearchParams,
      Object.entries(defaultValues)
    )
  }

  function loadFiltersBySearchParams(params: URLSearchParams) {
    const entries = params.entries()
    const formattedEntries: Array<[string, string | Date]> = []
    for (const [key, value] of entries) {
      let newValue: string | Date = value || ''
      const isDate = stringToDate(newValue)
      if (isDate !== null) {
        newValue = isDate
      }
      formattedEntries.push([key, newValue])
    }
    const paramEntries = Object.fromEntries(formattedEntries)
    resetForm((prev) => ({ ...prev, ...paramEntries }))
  }

  useEffect(() => {
    loadFiltersBySearchParams(searchParams)
  }, [])

  return {
    states: {
      control,
      errors
    },
    actions: {
      handleSubmit,
      reset,
      watch,
      clearErrors
    }
  }
}
